import { LoaderIcon } from '@/assets';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  withText?: boolean;
}

export const Loader = ({ className, withText = true }: Props) => {
  const { t } = useTranslation();

  const loaderImage = (
    <img
      src={ LoaderIcon }
      alt={ t('loading') }
      role="presentation"
      aria-label={ t('ariaLabels.loading') }
      className={ cn('animate-spin size-10', className) }
    />
  );

  if (!withText) return loaderImage;

  return (
    <div className="flex flex-col items-center gap-space-2xs">
      { loaderImage }
      <p>{ t('loading') }</p>
    </div>
  );
};
